export default {
  purchase: state => state.purchase,
  failPurchase : state => state.failPurchase,
  purchaseById : state => state.purchaseById,
  ekioskDashboardField : state => state.ekioskDashboardField,
  ekioskDashboardData : state => state.ekioskDashboardData,
  kioskPassword : state => state.kioskPassword,
  kioskExpiry : state => state.kioskExpiry
}
